import { useEffect } from 'react';

import { useCommandPalette } from 'utils/commandPalette';

import { useConversationActions } from './useConversationActions';
import { useNavigationActions } from './useNavigationActions';
import { useQuickActions } from './useQuickActions';
import { useSettingsActions } from './useSettingsActions';
import { useWrapUpActions } from './useWrapUpActions';

/**
 * Registers default command palette actions by combining all focused action
 * hooks.
 */
export function useRegisterDefaultActions(): void {
  const { registerActions } = useCommandPalette();

  // Get actions from each focused hook
  const quickActions = useQuickActions();
  const conversationActions = useConversationActions();
  const wrapUpActions = useWrapUpActions();
  const navigationActions = useNavigationActions();
  const settingsActions = useSettingsActions();

  // Register all actions
  useEffect(() => {
    const allActions = [
      ...quickActions,
      ...conversationActions,
      ...wrapUpActions,
      ...navigationActions,
      ...settingsActions,
    ];
    const unregister = registerActions(allActions);

    return () => unregister();
  }, [
    conversationActions,
    navigationActions,
    quickActions,
    registerActions,
    settingsActions,
    wrapUpActions,
  ]);
}
